import { Routes } from '@angular/router';
import { AppLayoutComponent } from './ui/layout/app-layout/app-layout.component';
import { authGuard } from './infrastructure/guards/auth.guard';

// Definicion de rutas de la aplicacion.
// Las rutas protegidas se agrupan bajo el layout principal y requieren sesion activa.
// Las paginas se cargan de forma lazy para no bloquear la carga inicial.
export const routes: Routes = [
  // Rutas protegidas dentro del layout principal
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./ui/pages/home/home.component').then(
            (m) => m.HomeComponent
          ),
        title: 'Inicio | Merck CRM',
      },
      {
        path: 'app/patologias',
        loadComponent: () =>
          import('./ui/pages/patologias/patologias.component').then(
            (m) => m.PatologiasComponent
          ),
        title: 'Patologías | Merck CRM',
      },
      {
        path: 'app/distribuidores',
        loadComponent: () =>
          import('./ui/pages/distribuidores/distribuidores.component').then(
            (m) => m.DistribuidoresComponent
          ),
        title: 'Distribuidores | Merck CRM',
      },
      {
        path: 'roles/listado',
        loadComponent: () =>
          import('./ui/pages/roles/listado/listado-roles.component').then(
            (m) => m.ListadoRolesComponent
          ),
        title: 'Listado de Roles | Merck CRM',
      },
      {
        path: 'roles/modulos-rol',
        loadComponent: () =>
          import('./ui/pages/roles/modulos-rol/modulos-rol.component').then(
            (m) => m.ModulosRolComponent
          ),
        title: 'Módulos por Rol | Merck CRM',
      },
      {
        path: 'app/roles/usuarios',
        loadComponent: () =>
          import('./ui/pages/roles/user-roles/user-roles.component').then(
            (m) => m.UserRolesComponent
          ),
        title: 'Roles de Usuario | Merck CRM',
      },
      {
        path: 'app/farmacias/cadenas',
        loadComponent: () =>
          import('./ui/pages/farmacias/cadenas/cadenas.component').then(
            (m) => m.CadenasComponent
          ),
        title: 'Cadenas de Farmacias | Merck CRM',
      },
      {
        path: 'app/farmacias/sucursales',
        loadComponent: () =>
          import('./ui/pages/farmacias/sucursales/sucursales.component').then(
            (m) => m.SucursalesComponent
          ),
        title: 'Sucursales de Farmacia | Merck CRM',
      },
      {
        path: 'farmacias/listado',
        loadComponent: () =>
          import('./ui/pages/farmacias/listado/listado-farmacias.component').then(
            (m) => m.ListadoFarmaciasComponent
          ),
        title: 'Farmacias | Merck CRM',
      },
      {
        path: 'farmacias/nueva',
        loadComponent: () =>
          import('./ui/pages/farmacias/nueva/nueva-farmacia.component').then(
            (m) => m.NuevaFarmaciaComponent
          ),
        title: 'Nueva Farmacia | Merck CRM',
      },
      {
        path: 'farmacias/editar/:id',
        loadComponent: () =>
          import('./ui/pages/farmacias/nueva/nueva-farmacia.component').then(
            (m) => m.NuevaFarmaciaComponent
          ),
        title: 'Editar Farmacia | Merck CRM',
      },
      {
        path: 'farmacias/solicitudes',
        loadComponent: () =>
          import('./ui/pages/farmacias/solicitudes/solicitudes-farmacia.component').then(
            (m) => m.SolicitudesFarmaciaComponent
          ),
        title: 'Solicitudes de Farmacias | Merck CRM',
      },
      {
        path: 'app/paises',
        loadComponent: () =>
          import('./ui/pages/paises/paises.component').then(
            (m) => m.PaisesComponent
          ),
        title: 'Países | Merck CRM',
      },
      {
        path: 'app/plataformas',
        loadComponent: () =>
          import('./ui/pages/plataformas/plataformas.component').then(
            (m) => m.PlataformasComponent
          ),
        title: 'Plataformas | Merck CRM',
      },
      {
        path: 'app/doctores/especialidades',
        loadComponent: () =>
          import('./ui/pages/doctores/especialidades/especialidades.component').then(
            (m) => m.EspecialidadesComponent
          ),
        title: 'Especialidades | Merck CRM',
      },
      {
        path: 'app/doctores',
        loadComponent: () =>
          import('./ui/pages/doctores/doctores.component').then(
            (m) => m.DoctoresComponent
          ),
        title: 'Doctores | Merck CRM',
      },
      {
        path: 'medicos/listado',
        loadComponent: () =>
          import('./ui/pages/medicos/listado/listado-medicos.component').then(
            (m) => m.ListadoMedicosComponent
          ),
        title: 'Médicos | Merck CRM',
      },
      {
        path: 'medicos/nuevo',
        loadComponent: () =>
          import('./ui/pages/medicos/nuevo/nuevo-medico.component').then(
            (m) => m.NuevoMedicoComponent
          ),
        title: 'Nuevo Médico | Merck CRM',
      },
      {
        path: 'medicos/editar/:id',
        loadComponent: () =>
          import('./ui/pages/medicos/nuevo/nuevo-medico.component').then(
            (m) => m.NuevoMedicoComponent
          ),
        title: 'Editar Médico | Merck CRM',
      },
      {
        path: 'app/provincias',
        loadComponent: () =>
          import('./ui/pages/provincias/provincias.component').then(
            (m) => m.ProvinciasComponent
          ),
        title: 'Provincias | Merck CRM',
      },
      {
        path: 'app/cantones',
        loadComponent: () =>
          import('./ui/pages/cantones/cantones.component').then(
            (m) => m.CantonesComponent
          ),
        title: 'Cantones | Merck CRM',
      },
      {
        path: 'app/distritos',
        loadComponent: () =>
          import('./ui/pages/distritos/distritos.component').then(
            (m) => m.DistritosComponent
          ),
        title: 'Distritos | Merck CRM',
      },
      {
        path: 'app/monedas',
        loadComponent: () =>
          import('./ui/pages/monedas/monedas.component').then(
            (m) => m.MonedasComponent
          ),
        title: 'Monedas | Merck CRM',
      },
      {
        path: 'app/productos',
        loadComponent: () =>
          import('./ui/pages/productos/productos.component').then(
            (m) => m.ProductosComponent
          ),
        title: 'Productos | Merck CRM',
      },
      {
        path: 'app/productos/marcas',
        loadComponent: () =>
          import('./ui/pages/productos/marcas/marcas.component').then(
            (m) => m.MarcasComponent
          ),
        title: 'Marcas de Productos | Merck CRM',
      },
      {
        path: 'app/productos/patologias',
        loadComponent: () =>
          import('./ui/pages/productos/patologias/patologias.component').then(
            (m) => m.ProductPatologiasComponent
          ),
        title: 'Productos por Patología | Merck CRM',
      },
      {
        path: 'app/productos/paises',
        loadComponent: () =>
          import('./ui/pages/productos/paises/paises.component').then(
            (m) => m.ProductPaisesComponent
          ),
        title: 'Productos por País | Merck CRM',
      },
      {
        path: 'app/paises/codigos-area',
        loadComponent: () =>
          import('./ui/pages/codigos-area/codigos-area.component').then(
            (m) => m.CodigosAreaComponent
          ),
        title: 'Códigos de Área | Merck CRM',
      },
      {
        path: 'app/usuarios',
        loadComponent: () =>
          import('./ui/pages/usuarios/usuarios.component').then(
            (m) => m.UsuariosComponent
          ),
        title: 'Usuarios | Merck CRM',
      },
      {
        path: 'app/roles',
        loadComponent: () =>
          import('./ui/pages/roles/roles.component').then(
            (m) => m.RolesComponent
          ),
        title: 'Roles | Merck CRM',
      },
      {
        path: 'app/reglas/cupones',
        loadComponent: () =>
          import('./ui/pages/reglas/cupones/cupones-reglas.component').then(
            (m) => m.CuponesReglasComponent
          ),
        title: 'Reglas de Cupones | Merck CRM',
      },
      {
        path: 'app/tracking/cupones',
        loadComponent: () =>
          import('./ui/pages/tracking/cupones/tracking-cupones.component').then(
            (m) => m.TrackingCuponesComponent
          ),
        title: 'Tracking de Cupones | Merck CRM',
      },
      {
        path: 'app/reportes/cupones/generados',
        loadComponent: () =>
          import('./ui/pages/reportes/cupones-generados/cupones-generados.component').then(
            (m) => m.CuponesGeneradosComponent
          ),
        title: 'Cupones Generados | Merck CRM',
      },
      {
        path: 'app/reportes/cupones/resumidos',
        loadComponent: () =>
          import('./ui/pages/reportes/cupones-resumidos/cupones-resumidos.component').then(
            (m) => m.CuponesResumidosComponent
          ),
        title: 'Cupones Resumidos | Merck CRM',
      },
      {
        path: 'app/permisos/rol',
        loadComponent: () =>
          import('./ui/pages/permisos/rol/rol.component').then(
            (m) => m.PermisosRolComponent
          ),
        title: 'Permisos por Rol | Merck CRM',
      },
    ],
  },
  // Rutas publicas de autenticacion (sin guard)
  {
    path: 'auth/login',
    loadComponent: () =>
      import('./ui/pages/auth-pages/sign-in/sign-in.component').then(
        (m) => m.SignInComponent
      ),
    title: 'Iniciar Sesión | Merck CRM',
  },
  {
    path: 'auth/sso/login',
    loadComponent: () =>
      import('./ui/pages/auth-pages/sso-callback/sso-callback.component').then(
        (m) => m.SsoCallbackComponent
      ),
    title: 'SSO Merck | Merck CRM',
  },
  // Cualquier ruta que no coincida cae aqui
  {
    path: '**',
    loadComponent: () =>
      import('./ui/pages/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
    title: 'Página no encontrada | Merck CRM',
  },
];
